import React from "react";
import ReactDOM from "react-dom";
import Amplify from "aws-amplify";
import { createClient } from "@liveblocks/client";
import { LiveblocksProvider } from "@liveblocks/react";

import { PersistGate } from "redux-persist/integration/react";
import { persistStore } from "redux-persist";
import { Provider } from "react-redux";

import store from "./store";

import App from "./App";
import "./assets/fonts/styles.css";
// import "./assets/fonts/stylesheet.css"
import "./index.css";
import * as serviceWorker from "./serviceWorker";

let persistor = persistStore(store);

console.log(process.env.REACT_APP_USER_POOL_WEB_CLIENT_ID);
Amplify.configure({
  Auth: {
    region: "eu-west-2", // (required) - Amazon Cognito Region
    userPoolId: process.env.REACT_APP_USER_POOL_ID, // (optional) - Amazon Cognito User Pool ID
    userPoolWebClientId: process.env.REACT_APP_USER_POOL_WEB_CLIENT_ID,
    oauth: {
      domain: process.env.REACT_APP_DOMAIN,
      scope: [
        "phone",
        "email",
        "openid",
        "profile",
        // "aws.cognito.signin.user.admin"
      ],
      redirectSignIn: process.env.REACT_APP_REDIRECT_SIGN_IN,
      redirectSignOut: process.env.REACT_APP_REDIRECT_SIGN_OUT,
      responseType: "token", // or 'token', note that REFRESH token will only be generated when the responseType is code
    },
    federationTarget: "COGNITO_USER_POOLS",
  },
});

const client = createClient({
  authEndpoint: "https://klen-multiplayer-nodejs.herokuapp.com/api/auth",
});

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <LiveblocksProvider client={client}>
        <PersistGate loading={null} persistor={persistor}>
          <App />
        </PersistGate>
      </LiveblocksProvider>
    </Provider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
